import React from 'react'
import PropTypes from 'prop-types'
import { Column, Slider } from '@sainsburys-tech/bolt'
import { GetComponent } from '../components/CMSComponents'
import { SliderContainer } from './UGLayout.styles'
import { trackDataLayerEvent, eventNames } from './tracking'

const initialTracking = (heading) => {
  trackDataLayerEvent(
    eventNames.carouselViewed,
    {},
    {
      impressionValue: `carousel:banners:${heading}:1`,
      interactionValue: 'carousel:banners:impression'
    },
    'Carousel Viewed'
  )
}

const interactionTracking = (index, heading) => {
  trackDataLayerEvent(
    eventNames.carouselInteraction,
    {},
    {
      impressionValue: `carousel:banners:${heading}:${index}`,
      interactionValue: 'carousel:banners:chevron'
    },
    'Carousel Interaction'
  )
}

const slides = (childrenArray, included, consumingGridType) => {
  const includedComponents = included || childrenArray

  return includedComponents.map((child, index) => {
    const sliderItem =
      consumingGridType === 'ug005' ? (
        <Column data-test='slider-container'>
          {included ? (
            <GetComponent
              {...child}
              index={index}
              consumingGridType={consumingGridType}
              positionInGrid={index}
              gridItems={includedComponents.length}
            />
          ) : (
            React.cloneElement(child, {
              index,
              consumingGridType,
              positionInGrid: index,
              gridItems: includedComponents.length
            })
          )}
        </Column>
      ) : (
        <SliderContainer
          xs={12}
          sm={6}
          block='md'
          md={4}
          lg={3}
          gutterSize='16px'
          numberOfColumns={12}
          data-test='slider-container'
          consumingGridType={consumingGridType}
        >
          <GetComponent {...{ ...child, index }} />
        </SliderContainer>
      )

    return sliderItem
  })
}

const UGSliderLayout = ({ childrenArray, included, consumingGridType, onSlideChange }) => {
  const isUg004 = consumingGridType === 'ug004'
  const isUg005 = consumingGridType === 'ug005'
  const includedComponents = included || childrenArray

  const formattedHeading = (child) => {
    const heading = child?.props?.heading || child?.heading
    return heading?.toLowerCase().replace(/[^a-zA-Z0-9]/g, '')
  }

  const handleSlideChange = (index) => {
    onSlideChange(index)
    interactionTracking(index, formattedHeading(includedComponents[index - 1]))
  }

  const slideProps = {
    itemsPerSlideXs: isUg004 ? 2 : 1,
    itemsPerSlideSm: isUg004 ? 2 : 1,
    itemsPerSlideMd: isUg004 ? 3 : 1,
    itemsPerSlideLg: isUg004 ? 4 : 1,
    itemsPerSlide: isUg005 ? 1 : undefined,
    isInfiniteCycle: true,
    numberOfSlides: isUg005 ? includedComponents.length : undefined,
    currentSlide: 1,
    showChevrons: true,
    onSlideChanged: isUg005 ? handleSlideChange : undefined,
    onSliderLoaded: isUg005 ? () => initialTracking(formattedHeading(includedComponents[0])) : undefined
  }

  return <Slider {...slideProps} items={slides(childrenArray, included, consumingGridType)} />
}

UGSliderLayout.propTypes = {
  childrenArray: PropTypes.node,
  included: PropTypes.array,
  consumingGridType: PropTypes.string.isRequired,
  onSlideChange: PropTypes.func
}

UGSliderLayout.defaultProps = {
  onSlideChange: () => {}
}

export default UGSliderLayout
